import React from "react";
import { Link } from "react-router-dom";

const Anchor = ({ value, href }) => {
    return <Link to={href}>{value}</Link>;
};

export default Anchor;
